import { CommonModule } from "@angular/common";
import { Component, HostBinding, inject, OnDestroy, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { Observable, Subscription } from "rxjs";
import { TranslationService } from "../../../../../../i18n";
import { UserType, AuthService } from "src/app/pages/auth";
import { environment } from "src/environments/environment";
import { TranslationModule } from "../../../../../../i18n";

interface LanguageFlag {
  lang: string;
  name: string;
  flag: string;
  active?: boolean;
}

const languages = [
  {
    lang: "en",
    name: "English",
    flag: "./assets/media/flags/united-states.svg",
  },
  {
    lang: "th",
    name: "Thai",
    flag: "./assets/media/flags/thailand.svg",
  },
];

@Component({
  selector: "app-user-inner",
  templateUrl: "./user-inner.component.html",
  imports: [CommonModule, NgbTooltipModule, RouterModule, TranslationModule],
})
export class UserInnerComponent implements OnInit, OnDestroy {
  @HostBinding("class")
  class = `menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px`;
  @HostBinding("attr.data-kt-menu") dataKtMenu = "true";

  language: LanguageFlag;
  user$: Observable<UserType>;
  langs = languages;
  environment = environment;
  private readonly auth = inject(AuthService);
  private readonly translationService = inject(TranslationService);
  private unsubscribe: Subscription[] = [];

  ngOnInit(): void {
    this.user$ = this.auth.currentUserSubject.asObservable();
    this.setLanguage(this.translationService.getSelectedLanguage());
  }

  logout() {
    this.auth.logout();
    // document.location.reload();
  }

  selectLanguage(lang: string) {
    this.translationService.setLanguage(lang);
    this.setLanguage(lang);
    // document.location.reload();
  }

  setLanguage(lang: string) {
    this.langs.forEach((language: LanguageFlag) => {
      if (language.lang === lang) {
        language.active = true;
        this.language = language;
      } else {
        language.active = false;
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
